function hideWtbModal(e) {
  const el = e.target;
  const isOutside = !el.closest(".ps-widget");
  if (isOutside || e.target.id === "closeWhereToBuy") {
    const modal = document.getElementById("whereToBuy");
    modal.classList.remove("show");
    modal.setAttribute("aria-hidden", true);
  }
}

function showWtbModal() {
  const modal = document.getElementById("whereToBuy");
  modal.classList.add("show");
  modal.setAttribute("aria-hidden", false);
}

function getSelectedVariantSku() {
  const selectedVariantScript = document.querySelector(
    "script[data-selected-variant]"
  );
  if (selectedVariantScript.textContent.trim() == "null") return null;
  const selectedVariant = JSON.parse(selectedVariantScript.textContent);
  const sku = selectedVariant.sku;
  return sku;
}

// Reload the widget with the new sku.
function updateWidgetSku(sku = undefined) {
  const widget = document.querySelector("#whereToBuy .ps-widget");
  if (!sku) {
    sku = getSelectedVariantSku();
  }
  if (widget) {
    widget.setAttribute("ps-sku", sku);
  }
}

// Hide the spinner when the widget shows.
function wtbWidgetDidUpdate() {
  const targetNode = document.querySelector(".ps-widget");
  const config = { attributes: true, childList: true, subtree: true };

  const callback = (mutationList, observer) => {
    const spinner = document.querySelector(".wtb-spinner");
    if (spinner) spinner.style.display = "none";
    observer.disconnect(); 
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

window.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector(".product-form form");
  const whereToBuyBtn = document.querySelector("button.where-to-buy");
  const whereToBuyModal = document.getElementById("whereToBuy");
  const initialSku = getSelectedVariantSku();

  if (initialSku) {
    updateWidgetSku(initialSku);
  }
  
  function tryRebind(attempts = 0) {
    if (window.PriceSpider && typeof window.PriceSpider.rebind === "function") {
      window.PriceSpider.rebind();
    } else if (attempts < 20) {
      setTimeout(() => tryRebind(attempts + 1), 250); // Retry every 250ms, up to 5s
    }
  }

  tryRebind();

  if (whereToBuyBtn) {
    whereToBuyBtn.addEventListener("click", function () {
      showWtbModal();
    });
  }

  whereToBuyModal.addEventListener("click", function (e) {
    hideWtbModal(e);
  });

  productForm.addEventListener("change", function (event) {
    if (event.target.matches('[name="id"]')) {
      updateWidgetSku();
      window.PriceSpider.rebind();
    }
  });

  wtbWidgetDidUpdate();
});
